import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};
const CREATEFEEDBACK = "createfeedback";

export default {
  feedbackCreated(payload) {
    return Repository.post(transformRoute(CREATEFEEDBACK), payload);
  },

  // DeleteCategory(payload) {
  //   return Repository.post(transformRoute(DELETECATEGORY), payload);
  // },
};

const transformRoute = (route) => {
  return `/feedback/${route}`;
};
